import { render, staticRenderFns } from "./InvestorTypeDropdown.vue?vue&type=template&id=5df43c06&"
import script from "./InvestorTypeDropdown.vue?vue&type=script&lang=js&"
export * from "./InvestorTypeDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports